import { __decorate } from "tslib";
import { customElement } from "@microsoft/fast-element";
import { AccordionItem, AccordionItemTemplate as template, } from "@microsoft/fast-foundation";
import { AccordionItemStyles as styles } from "./accordion-item.styles";
/**
 * The FAST Accordion Item Element. Implements {@link @microsoft/fast-foundation#AccordionItem},
 * {@link @microsoft/fast-foundation#AccordionItemTemplate}
 *
 *
 * @public
 * @remarks
 * HTML Element: \<fast-accordion-item\>
 */
let FASTAccordionItem = class FASTAccordionItem extends AccordionItem {
};
FASTAccordionItem = __decorate([
    customElement({
        name: "fast-accordion-item",
        template,
        styles,
    })
], FASTAccordionItem);
export { FASTAccordionItem };
/**
 * Styles for AccordionItem
 * @public
 */
export const AccordionItemStyles = styles;
